import { ChangeDetectionStrategy, Component, contentChild, Directive, input } from "@angular/core";
import { Card } from "primeng/card";

@Directive({ selector: "[kno2CardHeader]" })
export class Kno2CardHeader {}

@Directive({ selector: "[kno2CardTitle]" })
export class Kno2CardTitle {}

@Component({
    selector: "kno2-card",
    imports: [Card],
    template: `
        <p-card>
            @if (headerSlot()) {
                <div class="kno2-card-header">
                    <ng-content select="[kno2CardHeader]" />
                </div>
            }
            @if (titleSlot()) {
                <div class="kno2-card-title">
                    <ng-content select="[kno2CardTitle]" />
                </div>
            }
            <ng-content />
        </p-card>
    `,
    styles: `
        p-card {
            display: block;
            height: 100%;
        }
        .kno2-card-header {
            margin: calc(-1 * var(--p-card-body-padding, 1.5rem));
            margin-bottom: 0;
        }
        .kno2-card-title {
            margin-bottom: 0.75rem;
            font-size: var(--p-card-title-font-size);
            font-weight: var(--p-card-title-font-weight);
        }
    `,
    host: { "[style]": "cardStyle()" },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent {
    public readonly cardStyle = input<{ [klass: string]: unknown } | null>(null);
    protected readonly headerSlot = contentChild(Kno2CardHeader);
    protected readonly titleSlot = contentChild(Kno2CardTitle);
}
